
<div class="bi-switch" @click="toggle">
  <div
    class="toggle-switch mr-4"
    :class="{ checked: value, 'bc-red': color == toggleSwitchColors.red && value, 'bc-blue': color == toggleSwitchColors.blue && value }"
  />
  <div class="user-select-none">{{ label }}</div>
</div>
